module.exports = __webpack_public_path__ + "static/media/shippcart.67de4a0c.jpg";